export const pedestrianOneWayRoutesData = {
  title: "Pěší - jednosměrné trasy",
  introduction:
    "Trasy jsou pouze doporučené a účastníci si je mohou dle potřeb upravit. Každý se účastní na vlastní riziko.",
  downloadMapsComment: "Všechny trasy ke stažení.",
  downloadMapLink: "Odkaz na mapy.cz",
  mapsPath: "https://mapy.cz/s/ladovasete",
  routeDetails: [
    {
      subtitle: "Trasa B Landek - 16 km",
      routeDescription:
        "Hornické muzeum Landek kontrola 3) - Bažantnice Šilheřovice - Darkovičky (kontrola 4) - Hlučín",
      path: "https://mapy.cz/s/mosehajova",
      src: "/images/routes/trasa-B.png",
    },
    {
      subtitle: "Trasa Háj ve Slezsku - Hlučín - 14 km",
      routeDescription: "Háj ve Slezsku - Dobroslavice (kontrola 2) - Hlučín",
      path: "https://mapy.cz/s/porozalaju",
      src: "/images/routes/trasa-Haj-ve-Slezsku.png",
    },
    {
      subtitle: "Trasa F - Hrabyně - 25 km",
      routeDescription:
        "Štítina - Hrabyně (kontrola 1) - Padařov - Háj ve Slezsku - Dobroslavice (kontrola 2)",
      path: "https://mapy.cz/s/jokalanolo",
      src: "/images/routes/trasa-F.png",
    },
    {
      subtitle: "Trasa G - Bolatice - 20 km",
      routeDescription:
        "Bolatice (kontrola 5) - Darkovičky (kontrola 4) - Hlučín",
      path: "https://mapy.cz/s/danofotode",
      src: "/images/routes/trasa-G.png",
    },
    {
      subtitle: "Trasa G1 - Bolatice - Bělá - 25 km",
      routeDescription:
        "Bolatice (kontrola 5) - Bělá - Závada - Darkovičky (kontrola 4) - Hlučín",
      path: "https://mapy.cz/s/heputojebu",
      src: "/images/routes/trasa-G1.png",
    },
    {
      subtitle: "Trasa G2 - Chuchelná - Bělá - 21 km",
      routeDescription:
        "Chuchelná - Bělá - Závada - Darkovičky (kontrola 4) - Hlučín",
      path: "https://mapy.cz/s/lemutajodo",
      src: "/images/routes/trasa-G2.png",
    },
    {
      subtitle: "Trasa H - Kravaře - 36 km",
      routeDescription:
        "Štítina - Kravaře - Bolatice (kontrola 5) - Darkovičky (kontrola 4) - Hlučín",
      path: "https://mapy.cz/s/cehedevuva",
      src: "/images/routes/trasa-H.png",
    },
    {
      subtitle: "Trasa J - Hradec nad Moravicí - 39 km",
      routeDescription:
        "Hradec nad Moravicí - rozhledna Šance - Podvihov - Hrabyně (kontrola 1) - Háj ve Slezsku - Dobroslavice (kontrola 2) - Hlučín",
      path: "https://mapy.cz/s/dujezatuda",
      src: "/images/routes/trasa-J.png",
    },
    {
      subtitle: "Trasa K - Klimkovice 33 km",
      routeDescription:
        "Ostrava Poruba - Vřesina - Klimkovice - Zátiší - Hrabyně (kontrola 1) - Háj ve Slezsku - Dobroslavice (kontrola 2 ) - Hlučín",
      path: "https://mapy.cz/s/muvojufubu",
      src: "/images/routes/trasa-K.png",
    },
    {
      subtitle: "Trasa K1 - Zátiší - 21 km",
      routeDescription:
        "Zátiší - Budišovice - Hrabyně (kontrola 1) - Háj ve Slezsku - Dobroslavice (kontrola 2) - Hlučín",
      path: "https://mapy.cz/s/fevejovuhu",
      src: "/images/routes/trasa-K1.png",
    },
  ],
};
